import {
  AuditOutlined,
  DollarOutlined,
  DownloadOutlined,
  FileDoneOutlined,
  LoadingOutlined,
  MobileOutlined,
  ReloadOutlined,
  StopOutlined
} from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Descriptions,
  Result,
  Row,
  Space,
  Spin,
  message
} from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import FileSaver from 'file-saver';
import * as moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { SubSubtitleStart } from '../../components';
import CardDocumentPreview360 from '../../components/CardDocumentPreview360';
import MapView from '../../components/MapView';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { CONFIG } from '../../constants';
import UserContext from '../../context/user-context';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';
import { formatoMonedaGenerico } from '../../utils/converters';

const DocumentView = ({ documentos }) => {
  const screens = useBreakpoint();

  return (
    <>
      {screens && screens.md === true && (
        <Row gutter={[16, 16]} justify="start" align="middle">
          {documentos.map((doc) => (
            <Col key={doc.value}>
              <Button
                type="primary"
                onClick={() => {
                  if (doc.value.includes('Póliza')) {
                    window.open(
                      `${
                        CONFIG.URL_BASE
                      }/poliza/link-documentos-descarga?link=${
                        doc.link
                      }&filename=${doc.value.replace('Descargue su', '')}`,
                      '_blank'
                    );
                  } else {
                    window.open(doc.link, '_blank');
                  }
                }}
              >
                {doc.value}
              </Button>
            </Col>
          ))}
        </Row>
      )}
      {screens && screens.md === false && (
        <Space
          direction="vertical"
          style={{
            width: '100%'
          }}
        >
          {documentos.map((doc) => (
            <Button
              type="primary"
              block
              onClick={() => {
                window.open(doc.link, '_blank');
              }}
            >
              {doc.value}
            </Button>
          ))}
        </Space>
      )}
    </>
  );
};

function PolizaView(props) {
  const [fields, setFields] = useState();
  const { user } = useContext(UserContext);
  const [loading, setLoading] = useState();
  const [loadingFiles, setLoadingFiles] = useState();
  const [documentos, setDocumentos] = useState();
  const [documentosSistemaCore, setDocumentosSistemaCore] = useState();
  const [loadingLink, setLoadingLink] = useState();
  const [loadedLink, setLoadedLink] = useState();
  const [loadingCodigo, setLoadingCodigo] = useState();
  const [loadingAnulacion, setLoadingAnulacion] = useState();
  const [tieneApp, setTieneApp] = useState();
  const [loadingVoucher, setLoadingVoucher] = useState(false);
  const [polizaEstado, setPolizaEstado] = useState(false);
  const [tokenForRequests, setTokenForRequests] = useState(null);
  const history = useHistory();
  const location = useLocation();
  const consultarLink = async (linkSistemaCore, temporalToken) => {
    let link = linkSistemaCore;
    try {
      setLoadingLink(true);
      const response = await instanceRef.instance.get(
        `poliza/link-documentos/${temporalToken}`
      );
      setLoadingLink(false);
      setLoadedLink(true);
      if (response.data.data) {
        link = response.data.data;
        setDocumentosSistemaCore(link);
      } else {
        message.warning('Póliza en Proceso de Emisión');
        return;
      }
    } catch (err) {
      setLoadingLink(false);
      message.warning('Póliza en Proceso de Emisión');
      return;
    }

    if (link && (!user || (user && user['cognito:groups'][0] === 'CLIENTE'))) {
      enviarDatosUbicacion(temporalToken);
    }
  };

  const fetch = async () => {
    setLoading(true);
    const fullPath = location.pathname;
    // Variable para poder usar el token correcto ya que setTokenForRequests es asincrono y no esta disponible inmediatamente
    let temporalToken;
    try {
      const link = props.location.pathname.split('/')[1].replaceAll('/', '');
      const response = await instanceRef.instance.get(
        `/poliza/${props.match.params.id}/detalle-web?fullPath=${fullPath}`,
        {
          params: {
            link
          }
        }
      );
      if (response.data && response.data) {
        const isPublico =
          fullPath.includes('polizas-mail/') ||
          fullPath.includes('polizas-sms/');
        if (isPublico) {
          setTokenForRequests(response.data.data.token);
          temporalToken = response.data.data.token;
        } else {
          setTokenForRequests(props.match.params.id);
          temporalToken = props.match.params.id;
        }
      }
      setFields(response.data.data);
      if (response.data.data.manual || response.data.data.firma_manual) {
        setLoadingFiles(true);
        try {
          const responseDocumentos = await instanceRef.instance.get(
            `/poliza/files/${response.data.data.token}`
          );
          const baseURL = CONFIG.URL_BASE;

          const docs = responseDocumentos.data.data.map((item) => ({
            ...item,
            extension: item.tipo.split('.')[1],
            imagen: `${baseURL}/poliza/file/${temporalToken}?id=${item.id}`
          }));
          setDocumentos(docs);
        } catch (error) {
          errorHandler(error);
        }
        setLoadingFiles(false);
      } else {
        consultarLink(response.data.data.sebaot_link_documentos, temporalToken);
      }
      if (response.data.data.producto.codigo === 8) {
        setLoadingFiles(true);
        try {
          const responseDocumentos = await instanceRef.instance.get(
            `/poliza/files/${response.data.data.token}`
          );
          setDocumentos(responseDocumentos.data.data);
        } catch (error) {
          errorHandler(error);
        }
        setLoadingFiles(false);
      }
      if (response.data.data.estado) {
        setPolizaEstado(response.data.data.estado);
      }
      consultarTieneApp(temporalToken);
    } catch (error) {
      if (error.response && error.response.status === 400) {
        message.error(error.response.data.message);
        history.push(
          `/regenerar-token?flujo=poliza&tokenExpirado=${props.match.params.id}`
        );
      } else {
        message.error('Error al obtener datos de la póliza');
      }
    }
    setLoading(false);
  };
  const consultarTieneApp = async (token) => {
    try {
      await instanceRef.instance.get(`/poliza/${token}/tiene-app`);
      setTieneApp(true);
    } catch (error) {
      setLoading(false);
    }
  };

  const getNumeroPoliza = () => {
    return fields?.numero
      ? `${fields.seccion || ''}-${fields.numero || ''}-${
          fields.endoso === null ? '' : fields.endoso
        }`
      : 'SIN NÚMERO';
  };

  const getVoucher = async () => {
    setLoadingVoucher(true);
    const baseURL = CONFIG.URL_BASE;
    await FileSaver.saveAs(
      `${baseURL}/poliza/file/${tokenForRequests}?id=${documentos[0].id}`,
      'Voucher'
    );
    setLoadingVoucher(false);
  };

  const setDatosAcceso = (data, temporalToken) => {
    instanceRef.instance.put(`/poliza/${temporalToken}/datos-acceso`, data);
  };

  const enviarDatosUbicacion = async (temporalToken) => {
    setDatosAcceso(
      {
        link: props.location.pathname.split('/')[1].replaceAll('/', '')
      },
      temporalToken
    );
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function test(position) {
          setDatosAcceso(
            {
              link: props.location.pathname.split('/')[1].replaceAll('/', ''),
              latitud: position.coords.latitude,
              longitud: position.coords.longitude
            },
            temporalToken
          );
        },
        function error() {
          setDatosAcceso(
            {
              link: props.location.pathname.split('/')[1].replaceAll('/', '')
            },
            temporalToken
          );
        }
      );
    }
  };

  const getTextoRecibido = (recibido) => {
    switch (recibido) {
      case 'polizas':
        return 'Desde la web con la sesión iniciada';
      case 'polizas-mail':
        return 'Desde el enlace enviado a su correo';
      case 'polizas-sms':
        return 'Desde el enlace enviado por SMS';
      default:
        return '';
    }
  };

  const handleOpenUrl = (url) => {
    history.push(url);
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAnulacion = async () => {
    if (user && user['cognito:groups'][0] !== 'CLIENTE') {
      history.push(`/polizas/anulacion-poliza/${tokenForRequests}`);
    } else {
      try {
        setLoadingAnulacion(true);
        const response = await instanceRef.instance.post(
          `poliza/${tokenForRequests}/envio-mail-anulacion-poliza`
        );
        setLoadingAnulacion(false);
        if (response.data.data) {
          const correo = response.data.data;
          message.success(`Se envió un enlace de confirmación a ${correo}`);
        } else {
          message.warning('Error al solicitar anulación de póliza.');
          return;
        }
      } catch (err) {
        setLoadingAnulacion(false);
        errorHandler(err);
      }
    }
  };

  return (
    <>
      <ResponsiveContainer size="large">
        <Spin spinning={loading}>
          <Card
            title={`Póliza Nro.: ${getNumeroPoliza()}`}
            style={{ textAlign: 'left' }}
          >
            {fields && (
              <>
                {!(fields.manual || fields.firma_manual) && (
                  <>
                    <Button
                      type="link"
                      icon={<DownloadOutlined />}
                      loading={loadingLink}
                      onClick={async () => {
                        if (fields.sebaot_link_documentos) {
                          window.open(
                            `${fields.sebaot_link_documentos}`,
                            '_blank'
                          );
                        } else {
                          consultarLink(
                            fields.sebaot_link_documentos,
                            tokenForRequests
                          );
                        }
                      }}
                    >
                      Póliza y Factura
                    </Button>

                    <Button
                      type="link"
                      icon={<DollarOutlined />}
                      size="middle"
                      onClick={() =>
                        handleOpenUrl(`/polizas/estado/${tokenForRequests}`)
                      }
                    >
                      Estado de cuenta
                    </Button>
                  </>
                )}

                {fields.producto.codigo === 1 && (
                  <Button
                    type="link"
                    icon={<AuditOutlined />}
                    size="middle"
                    onClick={() =>
                      handleOpenUrl(
                        `/inspecciones/edit/${fields.solicitud.inspeccion.token}`
                      )
                    }
                  >
                    Inspección
                  </Button>
                )}
                <Button
                  type="link"
                  icon={<FileDoneOutlined />}
                  size="middle"
                  onClick={() =>
                    handleOpenUrl(`/solicitudes/${fields.solicitud.token}`)
                  }
                >
                  Solicitud
                </Button>
                {fields.producto.codigo === 8 && (
                  <Button
                    type="link"
                    icon={<AuditOutlined />}
                    size="middle"
                    loading={loadingVoucher}
                    onClick={() => getVoucher()}
                  >
                    Voucher
                  </Button>
                )}
                {tieneApp && (
                  <Button
                    type="link"
                    icon={<MobileOutlined />}
                    loading={loadingCodigo}
                    onClick={async () => {
                      try {
                        setLoadingCodigo(true);
                        const response = await instanceRef.instance.post(
                          `poliza/${tokenForRequests}/codigo`
                        );
                        setLoadingCodigo(false);
                        if (response.data.data) {
                          const { correo } = response.data.data;
                          message.success(
                            `Se envió un código de acceso a ${correo}`
                          );
                        } else {
                          message.warning(
                            'Error al generar el código de acceso'
                          );
                          return;
                        }
                      } catch (err) {
                        setLoadingCodigo(false);
                        errorHandler(err);
                      }
                    }}
                  >
                    Generar código para app
                  </Button>
                )}
                {user && polizaEstado !== 'ANULADO' && (
                  <Button
                    type="link"
                    icon={<StopOutlined />}
                    loading={loadingAnulacion}
                    onClick={handleAnulacion}
                  >
                    Solicitar anulación de póliza
                  </Button>
                )}
                <br />
                <br />
                <Descriptions
                  title="Datos de la Póliza"
                  style={{ textAlign: 'left', paddingBottom: 40 }}
                  column={{ md: 2, sm: 1, xs: 1 }}
                  bordered
                  size="small"
                >
                  <Descriptions.Item label="Fecha de emisión" span={2}>
                    {fields.fecha_emision &&
                      moment.utc(fields.fecha_emision).format('DD/MM/YYYY')}
                  </Descriptions.Item>
                  <Descriptions.Item label="Inicio de Vigencia">
                    {fields.fecha_inicio_vigencia &&
                      moment
                        .utc(fields.fecha_inicio_vigencia)
                        .format('DD/MM/YYYY')}
                  </Descriptions.Item>
                  <Descriptions.Item label="Fin de Vigencia">
                    {fields.fecha_fin_vigencia &&
                      moment
                        .utc(fields.fecha_fin_vigencia)
                        .format('DD/MM/YYYY')}
                  </Descriptions.Item>
                  <Descriptions.Item label="Total de cuotas">
                    {fields.total_cuotas}
                  </Descriptions.Item>
                  <Descriptions.Item label="Premio">
                    {formatoMonedaGenerico(fields.moneda, fields.premio)}
                  </Descriptions.Item>
                </Descriptions>
                {fields.manual || fields.firma_manual ? (
                  <>
                    <SubSubtitleStart>Documentos</SubSubtitleStart>
                    {loadingFiles && <LoadingOutlined />}
                    <Row gutter={[16, 16]} justify="start" align="middle">
                      {documentos &&
                        documentos.map((doc) => (
                          <Col key={doc.id}>
                            <Card
                              size="small"
                              title={doc.descripcion}
                              bodyStyle={{
                                paddingTop: 1,
                                paddingLeft: 0,
                                paddingRight: 0,
                                paddingBottom: 0
                              }}
                            >
                              <CardDocumentPreview360
                                cardProps={{
                                  bordered: false,
                                  onClick: () => {
                                    window.open(doc.imagen, '_blank');
                                  }
                                }}
                                documentProps={{
                                  file: doc.imagen
                                }}
                              />
                            </Card>
                          </Col>
                        ))}
                    </Row>
                  </>
                ) : (
                  <>
                    <SubSubtitleStart
                      style={{ fontWeight: 600, fontSize: 16, lineHeight: 1.5 }}
                    >
                      Documentos
                    </SubSubtitleStart>

                    <Spin
                      spinning={loadingLink && !loadedLink}
                      tip="Cargando..."
                    >
                      {documentosSistemaCore &&
                      documentosSistemaCore.length > 0 ? (
                        <DocumentView documentos={documentosSistemaCore} />
                      ) : (
                        <>
                          {loadedLink && (
                            <Result
                              title="Documentos pendientes de digitalización"
                              extra={
                                <Button
                                  type="primary"
                                  icon={<ReloadOutlined />}
                                  loading={loadingLink}
                                  onClick={async () => {
                                    consultarLink(
                                      fields.sebaot_link_documentos,
                                      tokenForRequests
                                    );
                                  }}
                                >
                                  Consultar
                                </Button>
                              }
                            />
                          )}
                        </>
                      )}
                    </Spin>
                    <br />
                  </>
                )}
                {fields && user && user['cognito:groups'][0] !== 'CLIENTE' && (
                  <>
                    <br />
                    <Descriptions
                      title="Datos de acceso a la póliza"
                      style={{ textAlign: 'left', paddingBottom: 40 }}
                      column={{ md: 2, sm: 1, xs: 1 }}
                      bordered
                      size="small"
                    >
                      <Descriptions.Item label="Accedió por última vez">
                        {fields.fecha_recibido
                          ? moment(fields.fecha_recibido).format(
                              'DD-MM-YYYY HH:mm'
                            )
                          : 'Aún no ha accedido'}
                      </Descriptions.Item>
                      <Descriptions.Item label="Vía de acceso">
                        {getTextoRecibido(fields.recibido)}
                      </Descriptions.Item>
                      <Descriptions.Item label="Información adicional">
                        {fields.info_recibido}
                      </Descriptions.Item>
                    </Descriptions>
                    {fields.latitud_recibido && fields.longitud_recibido && (
                      <MapView
                        coordenadas={{
                          lat: fields.latitud_recibido,
                          lng: fields.longitud_recibido
                        }}
                        zoom={15}
                        marker
                        readOnly
                      />
                    )}
                  </>
                )}
                {/* <SubSubtitleStart>Póliza y Factura </SubSubtitleStart>
                {fields.sebaot_link_documentos ? (
                  <PolizaiFrame
                    title="Consulta de póliza"
                    url={fields.sebaot_link_documentos}
                  />
                ) : (
                  <Result
                    title="Póliza en proceso de emisión"
                    extra={
                      <Button
                        type="primary"
                        icon={<ReloadOutlined />}
                        loading={loadingLink}
                        onClick={async () => {
                          consultarLink();
                        }}
                      >
                        Consultar
                      </Button>
                    }
                  />
                )} */}
              </>
            )}
          </Card>
        </Spin>
      </ResponsiveContainer>
    </>
  );
}

export default PolizaView;
